// biome-ignore lint/style/noRestrictedImports: component usage
import { Root } from "@radix-ui/react-collapsible";
import React from "react";

import { cx } from "~/tools/class-variance";

export type CollapsibleProps = React.ComponentPropsWithoutRef<typeof Root>;

export const Collapsible = React.forwardRef<HTMLDivElement, CollapsibleProps>((props, ref) => (
	<Root ref={ref} {...props} className={cx("group/collapsible", props.className)} />
));

if (import.meta.env.DEV) {
	Collapsible.displayName = "Collapsible";
}
